import { Reveal, SectionHead } from "./Reveal";
import PanoViewer from "./PanoViewer";

const PANO_IMG =
    "https://images.unsplash.com/photo-1742844552699-2fb71ad66a72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxlcXVpcmVjdGFuZ3VsYXIlMjAzNjAlMjBwYW5vcmFtYSUyMGludGVyaW9yJTIwbW9kZXJuJTIwbHV4dXJ5JTIwbG9iYnklMjByb29tJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4OTAyNjE3Nnww&ixlib=rb-4.1.0&q=85&w=3600&h=1800&fit=crop";

const HOTSPOTS = [
    { pitch: -2, yaw: 40, text: "Reception Lounge — 8K HDR clarity" },
    { pitch: 4, yaw: 160, text: "Interactive hotspot: embed videos, menus & links" },
    { pitch: -6, yaw: -95, text: "Google Maps ready — publish straight to Street View" },
];

export default function Vision() {
    return (
        <section id="vision" className="relative py-20 lg:py-32" data-testid="vision-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid items-end gap-10 lg:grid-cols-2">
                    <SectionHead
                        chapter="01"
                        eyebrow="Customer Vision"
                        title="SEE YOUR BUSINESS FROM EVERY ANGLE"
                        sub="Let them wander your lobby, peek into rooms and soak in the vibe — from their phone, on their schedule. By the time they visit, they'll already feel like regulars."
                    />
                    <Reveal delay={0.2} className="lg:text-right">
                        <p className="text-lg font-medium italic text-[#00C6FF] sm:text-xl">
                            "Your customers don't just see your business.
                            <br />
                            They experience it."
                        </p>
                    </Reveal>
                </div>

                <Reveal delay={0.15} className="mt-12">
                    <PanoViewer
                        image={PANO_IMG}
                        hotspots={HOTSPOTS}
                        testIdPrefix="vision-pano"
                        heightClass="h-[68vh] min-h-[440px]"
                    />
                </Reveal>
            </div>
        </section>
    );
}
